import { ControlCommunicationService } from '@app/form-builder/services/control-communication.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService, AuthenticationService, RequestsService, ReviewsService, EvaluationsService, UsersService, InspectionsService, RecordsService, FilesService } from '@app/core/services'
import { DomSanitizer } from '@angular/platform-browser'
import { first } from 'rxjs/operators';
import { Packer } from "docx";
import { Router } from '@angular/router';
import { User } from '@app/core/models';
import { Subscription } from 'rxjs';

@Component({
    selector: 'modal-preview-update-files',
    templateUrl: 'modal-preview-update-files.component.html',
    styleUrls: ['../../../app.component.scss']
})
export class ModalPreviewUpdateFiles implements OnInit, OnDestroy {
    @Input() name
    @Input() title
    @Input() recordId
    // @Input() inspectionId
    @Input() formId

    // Loaders
    loading = true
    saving = false

    // Form data
    currentForm = null
    submission = null
    requirements = null
    
    // Files
    files = []
    percentage = 0

    // Subscription
    private subscriptions: Subscription

    constructor(
        public modal: NgbActiveModal,
        private formCommunication: ControlCommunicationService,
        private alertService: AlertService,
        private recordsService: RecordsService,
        private requestsService: RequestsService,
        private fileService: FilesService,
    ) {
        this.subscriptions = this.formCommunication.changeEmmited$.subscribe(async msg => {
            if (msg.identifier === 'send-form' && this.saving) {
                const formGroup = msg.form as FormGroup

                try {
                    // await this.requestsService.changeFilesIntoUrls(formGroup, this.currentForm.id, this.recordId)
                    await this.fileService.changeFilesIntoUrls(formGroup, this.currentForm.id, this.recordId)
                } catch (error) {
                    //console.log(error)
                }

                this.recordsService.submitFormUpdateFiles(this.recordId, this.formId, formGroup.value)
                    .pipe(first())
                    .subscribe(
                        response => {
                            this.saving = false
                            this.alertService.success('Archivos actualizados correctamente', { autoClose: true })
                            modal.close('Archivos actualizados correctamente')
                        },
                        error => {
                            this.saving = false
                            this.alertService.error(error, { autoClose: true })
                        }
                    )
            } else if(msg.identifier === 'send-form') {
                // Get data from formGroup
                const formGroup = msg.form as FormGroup
                const f = formGroup.value
                var data = f

                // Set values to form
                setTimeout(() => {
                    this.formCommunication.emitEvent({
                        identifier: 'set-values',
                        form: data,
                    })
                }, 100)
            } else if(msg.identifier == 'file') {
                let added = false
                for (var i in this.files) {
                    const file = this.files[i]
                    if (file.formname == msg.formname && file.atIndex == msg.atIndex) {
                        this.files[i] = msg
                        added = true
                        break
                    }
                }
                if (!added) {
                    this.files.push(msg)
                }
            } else if (msg.identifier == 'uploading') {
                this.percentage = msg.percentage
            }
        })
    }

    ngOnInit() {
        this.recordsService.getFormUpdateFiles(this.recordId, this.formId)
            .pipe(first())
            .subscribe(
                response => {
                    this.currentForm = response.form
                    this.submission = response.submission
                    this.requirements = response.requirements

                    if (this.submission !== null) {
                        let lastForm = {};
                        for (let i in this.submission) {
                            const obj = this.submission[i];
                            lastForm[obj.name] = obj.value;
                        }
                        setTimeout(() => {
                            this.formCommunication.emitEvent({
                                identifier: 'set-values',
                                form: lastForm
                            });
                        }, 100);
                    }

                    setTimeout(() => {
                        this.formCommunication.emitEvent({
                            identifier: 'submit'
                        })

                        this.loading = false
                    }, 100);
                },
                error => {
                    this.loading = false
                    this.alertService.error(error, { autoClose: true })
                }
            )
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe()
    }

    save() {
        this.saving = true
        this.formCommunication.emitEvent({
            identifier: 'submit'
        })
    }
}